<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from "vue-router";

import PageWrapper from "@/common/components/PageWrapper.vue";
import { useGetFabricksPartnerByIdQuery } from "@/fabricks/partners/api/queries";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const route = useRoute("/fabricks/partners/[partnerId]");
const partnerId = ref(route.params.partnerId);
const { data: partner, isPending: isPending } = useGetFabricksPartnerByIdQuery(
  partnerId.value,
);
</script>

<template>
  <PageWrapper
    :is-pending="isPending"
    :title="partner?.name"
    :breadcrumb-links="[
      {
        label: 'All Partners',
        to: '/fabricks/partners',
      },
      {
        label: 'Partner details',
        to: '#',
      },
    ]"
  >
    <div v-if="partner">
      <RouterView
        v-slot="{ Component }"
        :partner="partner"
      >
        <Transition
          mode="out-in"
          name="fade"
        >
          <component
            :is="Component"
            :partner="partner"
          />
        </Transition>
      </RouterView>
    </div>
  </PageWrapper>
</template>
